import React, { useEffect, useState } from 'react';
import api from '../../../utils/api';

const TYPE_BADGES = {
  'credit': 'bg-green-100 text-green-800 ring-green-500/20',
  'debit': 'bg-red-100 text-red-800 ring-red-500/20',
};

const Credits = ({ user }) => {
  const [logs, setLogs] = useState([]);
  const [filtered, setFiltered] = useState([]);
  const [loading, setLoading] = useState(true);
  const [emptyState, setEmptyState] = useState(false);
  const [filterType, setFilterType] = useState('');
  const [query, setQuery] = useState('');
  const [currentPage, setCurrentPage] = useState(1);
  const itemsPerPage = 11;

  useEffect(() => {
    const fetchCredits = async () => {
      try {
        console.log(`Attempting to fetch credits for user ${user.id} at /api/credit-log/${user.id}/log`);
        const res = await api.get(`/api/credit-log/${user.id}/log`);
        if (!res.data.length) {
          console.log('No credit logs found for user', user.id);
          setEmptyState(true);
        }
        setLogs(res.data);
      } catch (err) {
        console.error('Error al obtener los créditos:', err.response ? err.response.data : err.message);
        setEmptyState(true);
      } finally {
        setLoading(false);
      }
    };
    fetchCredits();
  }, [user.id]);

  useEffect(() => {
    const result = logs.filter((log) =>
      (!filterType || (log.amount_added > 0 && filterType === 'credit') || (log.amount_added < 0 && filterType === 'debit')) &&
      (!query || log.note.toLowerCase().includes(query.toLowerCase()))
    );
    setFiltered(result);
    setCurrentPage(1);
  }, [logs, filterType, query]);

  const paginated = filtered.slice((currentPage - 1) * itemsPerPage, currentPage * itemsPerPage);
  const totalPages = Math.ceil(filtered.length / itemsPerPage);

  if (loading) return <p className="p-6 text-center text-sm">Cargando...</p>;

  if (emptyState) {
    return (
      <div className="text-center py-20 text-gray-500">
        <svg className="mx-auto h-10 w-10 text-gray-300" fill="none" stroke="currentColor" strokeWidth="1.5" viewBox="0 0 24 24">
          <path strokeLinecap="round" strokeLinejoin="round" d="M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z" />
        </svg>
        <h3 className="mt-2 text-sm font-semibold text-gray-900">Sin movimientos registrados</h3>
        <p className="mt-1 text-sm text-gray-500">Este cliente aún no tiene historial de créditos.</p>
      </div>
    );
  }

  return (
    <div className="space-y-6">
      <div className="flex justify-between gap-4">
        <input
          type="text"
          placeholder="Buscar en notas"
          value={query}
          onChange={(e) => setQuery(e.target.value)}
          className="w-1/2 border border-gray-300 rounded px-3 py-2 text-sm"
        />
        <select
          value={filterType}
          onChange={(e) => setFilterType(e.target.value)}
          className="w-1/3 border border-gray-300 rounded px-3 py-2 text-sm"
        >
          <option value="">Todos los movimientos</option>
          <option value="credit">Créditos</option>
          <option value="debit">Débitos</option>
        </select>
      </div>

      <div className="space-y-4">
        {paginated.map((log) => (
          <div
            key={log.id}
            className="flex justify-between items-center border border-gray-200 rounded-lg px-4 py-3 bg-white shadow-sm"
          >
            <div>
              <p className="text-sm font-medium text-gray-900">{log.note || 'Sin nota'}</p>
              <p className="text-xs text-gray-500">
                {new Date(log.created_at).toLocaleString()} — Anterior: {log.previous_balance} / Nuevo: {log.new_balance}
              </p>
            </div>
            <span
              className={`inline-flex items-center rounded-md px-2 py-1 text-xs font-medium ring-1 ring-inset ${
                log.amount_added >= 0
                  ? TYPE_BADGES.credit
                  : TYPE_BADGES.debit
              }`}
            >
              {log.amount_added >= 0 ? `+${log.amount_added}` : log.amount_added}
            </span>
          </div>
        ))}
      </div>

      <div className="flex justify-between items-center pt-4 text-sm text-gray-600">
        <p>Página {currentPage} de {totalPages}</p>
        <div className="space-x-2">
          <button
            onClick={() => setCurrentPage((prev) => Math.max(prev - 1, 1))}
            disabled={currentPage === 1}
            className="px-3 py-1 border rounded disabled:opacity-50"
          >
            Anterior
          </button>
          <button
            onClick={() => setCurrentPage((prev) => Math.min(prev + 1, totalPages))}
            disabled={currentPage === totalPages}
            className="px-3 py-1 border rounded disabled:opacity-50"
          >
            Siguiente
          </button>
        </div>
      </div>
    </div>
  );
};

export default Credits;